import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import ConfirmModal from '../../../modal/ConfirmModal';
import Form from '../../../form/Form';
import DiscountFormConfig from './DiscountFormConfig';
import { useOffer } from '../../../../context/OfferProvider';
import LightButton from '../../../button/LightButton';
import { toast } from 'react-toastify';

const AddDiscount = ({ beforeDiscountAmount }) => {
  const { manualDiscounts, setManualDiscounts, canModifyPayments } = useOffer();

  if (!canModifyPayments) {
    return <></>;
  }

  const [openDiscount, setOpenDiscount] = useState(false);
  const [discountReady, setDiscountReady] = useState(false);

  const [discount, setDiscount] = useState();

  const addDiscount = () => {
    const newDiscountValue = parseFloat(discount.discountPercentage);

    const total =
      manualDiscounts.reduce((sum, d) => sum + parseFloat(d.value || 0), 0) +
      newDiscountValue;

    if (total > 100) {
      toast.warn('Nie można dodać rabatu — suma rabatów przekracza 100%');
      return;
    }

    setManualDiscounts([
      ...manualDiscounts,
      {
        uuid: `${Math.floor(Math.random() * 101010)}`,
        value: discount.discountPercentage,
        description: discount.description,
        automatic: false,
      },
    ]);
    setDiscount(undefined);
    setOpenDiscount(false);
  };

  return (
    <>
      <LightButton
        onClick={() => setOpenDiscount(true)}
        size="sm"
        title="Dodaj rabat"
      >
        <FontAwesomeIcon icon={faPlus} className="me-1" />
        Dodaj rabat
      </LightButton>

      {openDiscount && (
        <ConfirmModal
          show={openDiscount}
          setShow={setOpenDiscount}
          size="md"
          title="Dodaj rabat"
          ready={discountReady}
          onConfirm={addDiscount}
          form={
            <Form
              initialData={{
                beforeDiscount: beforeDiscountAmount,
              }}
              onReadyUpdate={setDiscountReady}
              formDataChanged={setDiscount}
              noActions={true}
              fields={DiscountFormConfig}
            />
          }
        />
      )}
    </>
  );
};

export default AddDiscount;
